<iotnet-map-popover
  icon="assets/images/icons/filter.svg"
  [buttonTitle]="'Global.Action.Filter' | translate"
  [highlighted]="filtering()"
>
  <div class="map-filter__panel">
    <div class="map-filter__section">
      <h3 class="map-filter__heading">{{ "Services.Filter.FilterByStatus" | translate }}</h3>
      @for (option of options; track option.value) {
        <button
          type="button"
          class="map-filter__option"
          [class.map-filter__option--active]="isActive(option.value)"
          (click)="toggleStatus(option.value)"
        >
          <span class="map-filter__option-title">
            <status-icon [status]="option.value"></status-icon>
            <span>{{ option.labelKey | translate }}</span>
          </span>
          <svg-icon src="assets/images/icons/x.svg" class="map-filter__option-close"></svg-icon>
        </button>
      }
    </div>

    @if (availableTags().length > 0) {
      <div class="map-filter__section">
        <h3 class="map-filter__heading">{{ "Services.Tags" | translate }}</h3>
        <service-tags
          class="map-filter__tags"
          [tags]="availableTags()"
          [firewallEnabled]="false"
          [interactive]="true"
          [activeTags]="activeTags()"
          (tagToggled)="toggleTag($event)"
        />
      </div>
    }
  </div>
</iotnet-map-popover>
